export default __webpack_public_path__ + "static/media/illustration-work-1-m@3x.1b3e068b.webp";